import {ShapeComponent} from "set-state-compare/build/shape-component.js"

export default class BaseComponent extends ShapeComponent {
  // Nothing yet.
}
